import React, { useEffect } from "react";
import { handleApiException, useHttp } from "../../services/HttpService";
import { getBetriebsInfoEndpoint } from "../../services/BetriebeService";
import useQueryParam from "../../utils/useQueryParam";
import usePathParam from "../../utils/usePathParam";
import { NUMBER } from "../../utils/URLUtils";

/**
 * Komponente, welche Informationen zum aktuell geöffneten Betrieb in der Navigationsleiste anzeigt.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
function BetriebsDescriptionComponent(props) {
    const modus = useQueryParam("modus");
    const id = usePathParam("id", NUMBER);

    const [{ data: betriebsInfo }, refetch] = useHttp(getBetriebsInfoEndpoint(id), {
        manual: true,
    });

    useEffect(() => {
        if (id) {
            refetch().catch((e) => handleApiException(e, "Error loading Betriebsinfo"));
        }
    }, [modus, id, refetch]);

    return (
        <li style={{ flexGrow: 1 }}>
            {betriebsInfo && (
                <div style={{ textAlign: "center" }}>
                    <strong>{betriebsInfo.bezeichnung}</strong>
                    {` (${betriebsInfo.betriebsstatus})`}
                </div>
            )}
        </li>
    );
}

export default BetriebsDescriptionComponent;
